/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import PropTypes from "prop-types";
import React, {Component} from "react";

export default class ContextWrapper extends Component {
  static propTypes = {
    __: PropTypes.func.isRequired,
    children: PropTypes.any.isRequired,
  };

  static childContextTypes = {
    __: PropTypes.func.isRequired,
  };

  getChildContext() {
    return {
      // Expose localization.
      __: this.props.__,
    };
  }

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ../render/components/ContextWrapper.jsx